export default {
    organisationBaseData: 'Data'
}
